// Letaky module constants
export const DEFAULT_LOCALE = "vi"

export const SUPPORTED_LOCALES = [
  { value: "vi", label: "Tiếng Việt" },
  { value: "en", label: "English" },
  { value: "cs", label: "Čeština" },
] as const

export const DEFAULT_PAGINATION = {
  page: 1,
  pageSize: 20,
  total: 0,
  current: 1,
} as const

export const FILTER_DEBOUNCE_DELAY = 400

export const SORT_PAGINATION_PARAMS = ["page", "limit", "asc", "desc"] as const
